import * as React from "react";
import JobsPanelContent from "@app/projects/network-assessment/JobsPanelContent";
import { FlyoutLink } from "@app/shared/Flyouts";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { UserInfo } from "@app/user/UserContext";

interface JobsPanelContentLinkProps {
    containerId: string;
    projectId: number;
    projectName: string;
    triggerElementOverride?: React.RefObject<HTMLButtonElement>;
    user: UserInfo;
}

class JobsPanelContentLink extends React.Component<JobsPanelContentLinkProps> {
    public render() {
        return (
            <FlyoutLink
                classNames="col-12 action-menu-item side-panel-link fw-normal"
                content={{
                    body: this.renderEditContent(),
                    title: `Jobs - ${this.props.projectName}`,
                }}
                size="60"
                testId="jobs-panel-content-link__flyout"
                triggerElementOverride={this.props.triggerElementOverride}
            >
              <span className="project-action-button"><QesIcon iconName={QesIcons.TerminalBrowser} isDecorative />Jobs</span>
            </FlyoutLink>
        )
    }

    private renderEditContent() {
        return (
            <JobsPanelContent
                projectId={this.props.projectId}
                projectName={this.props.projectName}
                user={this.props.user}
            />
        );
    }
}

export default JobsPanelContentLink;
